import { Box, CssBaseline, Fab, Fade, useScrollTrigger } from '@mui/material';
import { Outlet, useLoaderData, useParams, useRevalidator } from 'react-router-dom';
import Footer from './Footer';
import Nav from './Nav';
import './index.scss';
import { CssVarsProvider } from '@mui/joy';
import theme from './theme/defaultTheme';
import '@/assets/icons/lazymall-icon/styles.css';
import { useLazyMallAppBarHeight } from '@/store/lazyMallStore';
import LoginFormDialog from '@/components/Dialog/LoginFormDialog';
import AlertDialog from '@/components/Dialog/AlertDialog';
import LoginConfirmDialog from '@/components/Dialog/LoginConfirmDialog';
import MallIcon from './components/MallIcon';
import LoadingDialog from '@/components/Dialog/LoadingDialog';
import { FooterInfoDataType } from '@/router';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { getMallId, getMallInfo, isLogined } from '@/services/mallUser.service';
import { useAnonymousUserStore, useUserStore } from '@/store/userStore';
import { useAnonymousCartStore } from '@/store/anonymousCartStore';
import LazymallFavicon from '/images/favicon-space.ico';
import DialogComponent from '@/components/Dialog/Dialog';
import analytics from '@/utils/analytics';
import { useOrderNPayStore } from '@/store/orderNPayStore';
import { useOrderNumberStore } from '@/store/orderNumberStore';

const LazyMall = () => {
    const location = useLocation()
    analytics()
    const mallUserId = useUserStore((state) => state.mallUserId)
    const revalidator = useRevalidator()
    useEffect(() => {
        window.scrollTo(0, 0)
        if (!isLogined()) {
            const currentPathRouter = location.pathname.split('/')[3]
            const orderPage = [
                'tracking-info', 'order-detail-info', 'order-n-shipping-info',
                'refund', 'cancel'
            ]
            const isOrderPage = orderPage.filter(item => item.includes(currentPathRouter))
            if (isOrderPage.length !== 0) {
                useOrderNumberStore.setState({
                    isOrderPage: true
                })
            } else {
                useOrderNumberStore.setState({
                    isOrderPage: false
                })
            }
        }
    }, [location.pathname])
    useEffect(() => {
        revalidator.revalidate();
    }, [mallUserId])
    useEffect(() => {
        const payData = { ...useOrderNPayStore.getState() }
        const deleteTarget = Object.keys(payData)
            .filter(item => !isNaN(Number(item)))
            .filter(item => (new Date().getTime() - Number(item)) > 432000000) // 5일 후 삭제 432,000,000
        console.log(deleteTarget)
        const check = deleteTarget.length === 1 && deleteTarget[0] === ''
        if (check) return;
        deleteTarget.forEach(item => {
            delete payData[item]
        })
        console.log(payData)
        useOrderNPayStore.getState().update(payData)
    }, [])
    return (
        <CssVarsProvider theme={theme}>
            <CssBaseline />
            <MallContainer>
                <div id="back-to-top-anchor" />
                <Nav />
                <Box display={'flex'} flexDirection="column" flexGrow={1}>
                    <Outlet />
                </Box>
                {/* <Footer footerInfo={footerInfo} /> */}
                <ScrollToTopButton />
                <LoginFormDialog />
                <LoadingDialog />
                <AlertDialog />
                <DialogComponent />
            </MallContainer>
        </CssVarsProvider>
    );
};
export default LazyMall;

function MallContainer({ children }) {
    const params = useParams();
    const [name, setName] = useState('');
    const appBarHeight = useLazyMallAppBarHeight();

    useEffect(() => {
        getShopName()
        async function getShopName() {
            const { path } = params
            if (!path) return;
            const { mallId } = await getMallId(path);
            const shopName = await getMallInfo(mallId).then(r => {
                return r.mallInfo.name
            })
            setName(() => shopName)
        }
    }, [location.pathname])
    
    return (
        <>
            <Helmet>
                <link rel="icon" href={LazymallFavicon} />
                { name.trim() !== '' && (<title>{name}</title>)}
            </Helmet>
            <Box
                display="flex"
                flexDirection="column"
                width={'100%'}
                maxWidth="720px"
                minHeight={'100vh'}
                margin="auto"
                boxSizing="border-box"
                sx={{
                    '--app-bar-height': `${appBarHeight}px`,
                }}
            >
                {children}
            </Box>
        </>
    );
}

function ScrollToTopButton({}) {
    const trigger = useScrollTrigger({
        target: window ? window : undefined,
        disableHysteresis: true,
        threshold: 100,
    });

    return (
        <Fade in={trigger}>
            <Fab
                size="medium"
                color="primary"
                sx={{ position:'fixed', bottom:'2%', right:'2%'}}
                onClick={(e) => {
                    const anchor = ((e.target as HTMLDivElement).ownerDocument || document).querySelector(
                        '#back-to-top-anchor',
                    );
                    if (anchor) {
                        anchor.scrollIntoView({
                            block: 'center',
                        });
                    }
                }}
            >
                <MallIcon iconName="up-arrow" size="nav" />
            </Fab>
        </Fade>
    );
}
